import { useNavigate } from "react-router-dom";
import DetailRow from "../../../components/UI/viewDialogs/DetailRow";
import { formatDate } from "../../../functions/dateTime/formatDate";
import Modal from "../../../components/portal/Modal";
import GradientButton from "../../../components/UI/buttonUI/GradientButton";
import successIcon from "../../../assets/icons/successIcon.svg";
import { CylinderFillStatus } from "../utils/CylinderStatusOverview";

export default function CylinderViewDialog({ viewDetails }) {
  const navigate = useNavigate();
  return (
    <Modal modalWidth="view-dialog-content">
      <img src={successIcon} alt="messageIcon" className="mx-auto mb-1 w-9" />
      <p className="view-success-msg-d">Cylinder Successfully Registered!</p>
      <div className={`px-2 overflow-auto`}>
        <div className="dialog-sub-title">Registration Details</div>
        <div className="view-dialog-content-wrap">
          <DetailRow title="Cylinder No." value={viewDetails.serialNumber} />
          <DetailRow
            title="Fill Status"
            value={
              <CylinderFillStatus status={viewDetails.currentState.isFilled} />
            }
          />
          <DetailRow title="Size" value={`${viewDetails.size}kg`} />
          {viewDetails.receivedInFactoryAt && (
            <DetailRow
              title="Received Factory At"
              value={formatDate(viewDetails.receivedInFactoryAt)}
            />
          )}
        </div>
        <div className="dialog-sub-title">Station Details</div>
        <div className="view-dialog-content-wrap">
          <DetailRow title="Station ID" value={viewDetails.station.id} />
          <DetailRow title="Station Name" value={viewDetails.station.name} />
          <DetailRow
            title=" Jbcc Field Tech"
            value={viewDetails.station.jbccFieldTechnician.fullName}
          />
          <DetailRow
            title="Jbcc Field Tech Phone"
            value={viewDetails.station.jbccFieldTechnician.mobileNumber}
          />
        </div>
      </div>
      <div className="pt-5 text-center">
        <GradientButton
          btnText="Ok"
          width="w-28"
          onClick={() => navigate("/sites/cylinders")}
        />
      </div>
    </Modal>
  );
}
